import styled, { withTheme } from 'styled-components';
import RightArrowIcon from '../../assets/images/arrow.svg';
import LeftArrowBlueIcon from '../../assets/images/blue-arrow-icon.svg';

const ListItemIcon = styled.span.attrs((props) => ({
  className: props.className,
}))`
  background: url(\"${RightArrowIcon}\") no-repeat right top;
  &.left-blue {
    background: url(\"${LeftArrowBlueIcon}\") no-repeat right top;
  }
  background-size: 17px 17px;
  display: block;
  height: 17px;
  position: relative;
  width: 32px;
  ${(props) => props.theme.breakpoints.up('md')} {
    background-position: right center;
  }
`;

export default withTheme(ListItemIcon);
